import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { onAuthStateChangedListener, getUserRole } from "./firebaseServices";
import Login from "./Login";
import AdminPage from "./AdminPage";
import UserPage from "./UserPage";
import ProtectedRoute from "./ProtectedRoute";
import ResetPassword from "./ResetPassword";

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentRole, setCurrentRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChangedListener(async (user) => {
      setLoading(true);

      if (user) {
        try {
          const role = await getUserRole(user.uid);
          setCurrentUser(user);
          setCurrentRole(role);
        } catch (error) {
          console.error("Error fetching user role:", error);
        }
      } else {
        setCurrentUser(null);
        setCurrentRole(null);
      }

      setLoading(false);
    });

    return unsubscribe; // Make sure the effect cleans up correctly.
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show a loading message while auth state is being checked
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={currentUser ? currentRole === "admin" ? <AdminPage /> : <UserPage /> : <Login />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute user={currentUser} requiredRole="admin">
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user"
          element={
            <ProtectedRoute user={currentUser} requiredRole="user">
              <UserPage />
            </ProtectedRoute>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
}

export default App;
